import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { observer } from 'mobx-react-lite';
import { Card, CardActionArea, CardActions, CardContent, CardMedia, Divider, } from '@mui/material';
import { useTokens } from '@mcn-platform/models';
import AssetImage from '../../common/asset/AssetImage';
import CustomButton from '../../common/CustomButton';
import ItemHeadline from './ItemHeadline';
import ItemTitle from './ItemTitle';
const MediaCard = ({ section, size = 'large', action, }) => {
    const tokens = useTokens();
    const viewAction = () => {
        action(section.id);
    };
    return (_jsxs(Card, { sx: {
            width: '100%',
            boxShadow: 'rgba(17, 17, 26, 0.05) 0px 1px 0px, rgba(17, 17, 26, 0.1) 0px 0px 8px !important',
        }, children: [_jsx(CardActionArea, { onClick: () => {
                    if (action) {
                        viewAction();
                    }
                }, children: _jsx(CardMedia, { children: _jsx(AssetImage, { asset: section.item?.posterImage ? section.item?.posterImage : section.item?.asset, customStyle: { width: '100%', height: '200px', objectFit: 'cover' }, size: "thumb400w" }) }) }), _jsxs(CardContent, { children: [_jsx(ItemTitle, { title: section.name }), _jsx(ItemHeadline, { showTitle: false, headline: "", 
                        // isShowMore
                        description: section.item?.headline, 
                        // description=""
                        size: size })] }), _jsx(Divider, { sx: { marginX: 2 } }), _jsx(CardActions, { sx: {
                    marginBottom: 1,
                    alignItems: 'center',
                }, children: _jsx(CustomButton, { variant: "outlined", label: tokens.getToken('viewLessonLabel'), onClick: () => action && viewAction() }) })] }));
};
export default observer(MediaCard);
//# sourceMappingURL=LessonCard.js.map